import StatSmall from './StatSmall'

export default StatSmall